import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import React, { useState } from 'react'

import { StripePaymentProps } from './stripe-payment.types'
import { StripePaymentFields } from './stripe-payment-fields'

export const StripePayment = ({ ref, options }: StripePaymentProps) => {
  const [stripePromise] = useState(() => loadStripe(import.meta.env.VITE_STRIPE_KEY))
  return (
    <Elements options={options} stripe={stripePromise}>
      <StripePaymentFields ref={ref} />
    </Elements>
  )
}
